export const CARDS_EXTENSION_TYPE = 'com.atlassian.confluence.link-cards';
export const CARDS_EXTENSION_KEY = 'cards';

export const CARDS_EXTENSION_ANALYTIC_SOURCE = 'cardsExtension';
export const CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE = 'cardsExtensionConfig';
export const CARDS_EXTENSION_CONFIG_BACKGROUND_ANALYTIC_SOURCE =
	'cardsExtensionConfigBackgroundColor';
export const CARDS_EXTENSION_CONFIG_TEXT_ANALYTIC_SOURCE = 'cardsExtensionConfigTextColor';

export const CARDS_EXTENSION_VERSION_2 = '2';
export const CARDS_EXTENSION_VERSION_3 = '3';

export const CARDS_EXTENSION_VERSION_5 = '5';
